import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import ManageDeviceDialog from "@/app/settings/club/players/components/ManageDeviceDialog"
import PlayerInfo from "@/app/settings/club/players/components/PlayerInfo"
import PlayerTable from "@/app/settings/club/players/components/PlayerTable"
import RemovePlayerDialog from "@/app/settings/club/players/components/RemovePlayerDialog"
import { usePlayersQuery } from "@/hooks/api/useSettingQuery"
import Search from "@/components/form/search/Search"
import BasicButton from "@/components/button/BasicButton"
import { PAGE_SIZE } from "@/constants/pagination"
import { PlayerSetting } from "@/types/setting"

import "./playersAndDevices.scss"

export default function PlayersAndDevicesPage() {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false)
  const [selectedPlayer, setSelectedPlayer] = useState<number | undefined>()
  const [filteredPlayers, setFilteredPlayers] = useState<PlayerSetting[]>([])
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
  })

  const [keyword, setKeyword] = useState("")

  const { data: players, refetch } = usePlayersQuery()

  useEffect(() => {
    if (players) {
      setSelectedPlayer(
        selectedPlayer ||
          players.sort((a, b) => (a.uniformNumber ?? 0) - (b.uniformNumber ?? 0))[0]?.idfPlayer,
      )
    }
  }, [players])

  useEffect(() => {
    if (players) {
      setFilteredPlayers(
        players?.filter(
          (player) =>
            player.nickname.toLowerCase().includes(keyword.toLowerCase()) ||
            player.position.toLowerCase().includes(keyword.toLowerCase()) ||
            player.uniformNumber?.toString().includes(keyword) ||
            player.deviceSerial?.toLowerCase().includes(keyword.toLowerCase()),
        ),
      )
    }
  }, [keyword, players])

  return (
    <div className="PlayersAndDevicesCont">
      <div className="search-and-button">
        <Search onChange={setKeyword} />
        <BasicButton type="default-outlined" size="md" onClick={() => setIsDialogOpen(true)}>
          {t("button.manageDevices")}
        </BasicButton>
      </div>
      <ManageDeviceDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />

      <div className="PlayersAndDevicesTableCont">
        <PlayerTable
          data={filteredPlayers}
          selectedPlayer={selectedPlayer}
          setSelectedPlayer={setSelectedPlayer}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
        <PlayerInfo
          idfPlayer={selectedPlayer}
          openRemoveDialog={() => setIsRemoveDialogOpen(true)}
          refetch={refetch}
        />
      </div>
      <RemovePlayerDialog
        selectedPlayer={selectedPlayer}
        setSelectedPlayer={setSelectedPlayer}
        open={isRemoveDialogOpen}
        onClose={() => setIsRemoveDialogOpen(false)}
      />
    </div>
  )
}
